/**
 * The slot registrations of `web/sheets/pc` (2.H deliverable 8; CS r6c's row
 * `header.pills.character`, order 72): the header's "Character sheet" pill.
 * `apps/web/src/editor-services/slots.ts` collects them as `SLOT_MODULES['web/sheets/pc']`.
 */
import type { SlotRegistration, WorkPackageId } from '@codex/contracts';
import { CharacterPill } from './CharacterPill.js';

export const owner: WorkPackageId = '2.H';

export const slotRegistrations: readonly SlotRegistration[] = [
  { slot: 'header.pills', order: 72, owner: '2.H', component: CharacterPill },
];
